<!-- ----------------------------------------------- -->
<template>
  <v-col class="card">
    <if-detail></if-detail>
  </v-col>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 お知らせ検索
 * Info.vue
 * @author LIS
 */

/** お知らせ情報詳細カード */
import IfDetail from "../../components/pc/full/IfDetail.vue";

export default {
  components: {
    IfDetail
  }
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
.card {
  padding: 16px;
  height: 100%;

  & > :not(:first-child) {
    margin-top: 16px;
  }
}
</style>
